/**
 * Entry application component used to compose vendors and render Routes.
 * */

import React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { HelmetProvider, Helmet } from 'react-helmet-async';
// import { LastLocationProvider } from 'react-router-last-location';

import { Routes } from './app/router/Routes';
import { LayoutSplashScreen, ThemeProvider } from './_base';
import I18nProvider from './_base/i18n/I18nProvider';
import ThemeProviderMui from './app/theme/mui/ThemeProviderMui';

export default function App({ store, persistor, basename }) {
  return (
    /* Provide Redux store */
    <Provider store={store}>
      {/* Asynchronously persist redux stores and show `SplashScreen` while it's loading. */}
      <PersistGate persistor={persistor} loading={<LayoutSplashScreen />}>
        {/* Add high level `Suspense` in case if was not handled inside the React tree. */}
        <React.Suspense fallback={<LayoutSplashScreen />}>
          {/* Override `basename` (e.g: `homepage` in `package.json`) */}
          <BrowserRouter basename={basename}>
            {/* This library only returns the location that has been active before the recent location change in the current window lifetime. */}
            {/* <LastLocationProvider> */}
            {/* Provide Base theme overrides. */}
            <ThemeProviderMui>
              <ThemeProvider>
                {/* Provide `react-intl` context synchronized with Redux state.  */}
                <I18nProvider>
                  <HelmetProvider>
                    <Helmet>
                      <title>Chipscan</title>
                    </Helmet>
                    {/* Render routes with provided `Layout`. */}
                    <Routes />
                  </HelmetProvider>
                </I18nProvider>
              </ThemeProvider>
            </ThemeProviderMui>
            {/* </LastLocationProvider> */}
          </BrowserRouter>
        </React.Suspense>
      </PersistGate>
    </Provider>
  );
}
